const question2 = {
    'question': 'Jaki jest koszt wizyty domowej?',
    'answer': 'Koszt wizyty domowej zależy od wielu czynników, w tym: odległości między domem pacjenta a miejscem pracy lekarza. W celu uzgodnienia szczegółów wizyty, terminu oraz kosztów prosimy o kontakt telefoniczny z rejestracją, która przekaże lekarzowi potrzebne informacje. Przybliżony koszt wizyty to ok. 700 zł.'
}

export default question2;